
let getDate = (date) => {
    if (typeof date !== 'object') {
        date = new Date(date)
    } // Because of mongo(string) and kandy(number) return types
    return {
        date: date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
    }
}

let updateArrayItem = (array, selector, update) => {
	return array.map((item) => {
		if (selector(item)) {
            if (typeof update === 'function') {
                let data = update(item)
                return Object.assign({}, item, data)
            } else {
                return Object.assign({}, item, update)
            }
		}
		return item
	})
}

let unique = function(arr,key) {
    if((!arr||arr.length===0)) return arr;
    let ret;
    if (!key){
        ret=arr.reduce((tar,val)=>{
            if (tar.indexOf(val)===-1) tar.push(val);
            return tar;
        },[])

    } else {
        ret=arr.reduce((tar,val)=>{
            if(val &&val[key]&&(!(val[key] in tar))){
                tar[val[key]]=val;
            }
            return tar;
        },{});
        ret=Object.values(ret);
    }
    return ret;
}

export { updateArrayItem,getDate,unique}
